export default __webpack_public_path__ + "static/media/companions.04ebe8aa.jpg";